const selectDriverManagementSystem = (state: any) => state.get('driverManagementSystem');

export default selectDriverManagementSystem;
